import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import base_ds from "@/services/base_datasource_service";
import { Contractor } from "@/services/models-service";
import request from "@/utils/request";


export const route_ns = `dicts/contractor`;


interface ICachedContractors {
  [key: string]: Contractor[];
}

class ContractorService {
  public current: Contractor | null = null;
  public crud = base_ds.getBaseCrud(route_ns);
  public data_source = base_ds.getBaseDataSource(route_ns);

  // Презагруженные связки id срезки - contractor хранятся здесь, при изменении id узла обновляются полностью
  // или же частично добавляются срезки при выборе новых срезок
  public preloadedContractorsEcoNodeId: null | number = null;
  public cachedContractors: ICachedContractors = {};

  public setCurrent(value: Contractor) {
    this.current = value;
  }

  public async save(entity: Contractor): Promise<IResponseResult<Contractor>> {
    const response: AxiosResponse["data"] = await this.crud.save(entity);
    if (response) {
      return {data: response.data as Contractor};
    } else {
      return {data: null, message: ""};
    }
  }

  public async get(): Promise<IResponseResult<Contractor[]>> {
    const response: AxiosResponse["data"] = await this.crud.get();
    if (response && response.data) {
      return {data: response.data as Contractor[]};
    } else {
      return {data: null, message: ""};
    }
  }

  public async getById(entity: string): Promise<IResponseResult<Contractor>> {
    const response: AxiosResponse["data"] = await this.crud.get_by_id(entity);
    if (response) {
      return response;
    } else {
      return {data: null, message: ""};
    }
  }

  public async getWithFilter(id_cut: string, id_node: number): Promise<IResponseResult<Contractor[]>> {
    const route = route_ns + `?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_heat_node","=","${id_node}"]]`;
    const response: AxiosResponse["data"] = await request({
      url: route,
      method: "get",
    });
    if (response) {
      return response;
    } else {
      return {data: null};
    }
  }

  public async getFew(ids: string[], id_node: number): Promise<IResponseResult<ICachedContractors>> {
    let cuts_to_load = []; // итоговый список Id срезок для загрузки
    if (id_node !== this.preloadedContractorsEcoNodeId) {
      cuts_to_load = ids;
      this.cachedContractors = {};
      this.preloadedContractorsEcoNodeId = id_node;
    } else {
      // Если contractors для срезки уже загружены, не загружаем их заного
      cuts_to_load = ids.filter(cid => !this.cachedContractors.hasOwnProperty(cid))
    }
    if (cuts_to_load.length) {
      const route = route_ns + `/few_cut?filter=[["id_cut","in",${JSON.stringify(cuts_to_load)}],"and",["id_eco_heat_node","=","${id_node}"]]`;
      const response: AxiosResponse["data"] = await request({
        url: route,
        method: "get",
      });
      if (response.data) {
        this.cachedContractors = {...this.cachedContractors, ...response.data};
      }
    }
    return {data: this.cachedContractors};
  }
}

export default new ContractorService();
